import { Link } from 'react-router';
import { StapelLogo } from './stapel-logo';

export function Navbar() {
  return (
    <header className="sticky z-50 mx-4 flex justify-center transition-all duration-300 md:mx-0 top-6">
      <div style={{ width: '850px' }}>
        <div className="mx-auto max-w-7xl rounded-2xl transition-all duration-300 xl:px-0 px-2 border border-border backdrop-blur-lg bg-background/75">
          <div className="flex h-[56px] items-center justify-between p-4">
            <div className="flex-1 flex items-center">
              <a className="flex items-center gap-2" href="#hero">
                <StapelLogo size={140} color="#111" />
              </a>
            </div>
            <div className="hidden md:block">
              <ul className="relative flex w-fit rounded-full h-11 px-2 items-center justify-center">
                <li className="z-10 cursor-pointer h-full flex items-center justify-center px-4 py-2 text-sm font-medium transition-colors duration-200 text-black/70 hover:text-black tracking-tight">
                  <a href="#hero">Home</a>
                </li>
                <li className="z-10 cursor-pointer h-full flex items-center justify-center px-4 py-2 text-sm font-medium transition-colors duration-200 text-black/70 hover:text-black tracking-tight">
                  <a href="#features">Funktionen</a>
                </li>
                <li className="z-10 cursor-pointer h-full flex items-center justify-center px-4 py-2 text-sm font-medium transition-colors duration-200 text-black/70 hover:text-black tracking-tight">
                  <a href="#security">Sicherheit</a>
                </li>
                <li className="z-10 cursor-pointer h-full flex items-center justify-center px-4 py-2 text-sm font-medium transition-colors duration-200 text-black/70 hover:text-black tracking-tight">
                  <a href="#faq">FAQ</a>
                </li>
              </ul>
            </div>
            <div className="flex-1 flex flex-row items-center justify-end gap-1 md:gap-3">
              <Link to="/demo" className="hidden md:block">
                <button className="shrink-0 items-center justify-center rounded-lg border border-transparent text-sm font-medium whitespace-nowrap transition-all outline-none select-none active:translate-y-px bg-primary text-primary-foreground h-8 gap-1.5 px-3 py-0 leading-none flex cursor-pointer hover:bg-primary/90">
                  Demo anfragen
                </button>
              </Link>
              <Link to="/login" className="hidden md:block">
                <button className="shrink-0 items-center justify-center rounded-lg border border-border text-sm font-medium whitespace-nowrap transition-all outline-none select-none active:translate-y-px bg-background hover:bg-muted h-8 gap-1.5 px-3 py-0 leading-none flex cursor-pointer">
                  Login
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
